import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PageScroll } from '@/layouts/page-layout';
import { ContainerIcon } from 'lucide-react';
import ApkHubSection from './hub-section';

export default function ApkPage() {
	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-3'>
			<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
				<CardHeader className='border-b px-4 py-4 flex'>
					<div className='flex items-center gap-3'>
						<div className='rounded-lg bg-primary/10 p-2'>
							<ContainerIcon className='text-primary' size={20} />
						</div>
						<div>
							<CardTitle className='text-primary'>APK</CardTitle>
							<CardDescription>Билдер, домены и история сборок</CardDescription>
						</div>
					</div>
				</CardHeader>
				<CardContent className='px-4 py-4'>
					<ApkHubSection />
				</CardContent>
			</Card>
		</PageScroll>
	);
}
